import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import GeneralSettingsIcon from "../../assets/icons/settings.svg2";
import HelpButton from "../HelpContent/HelpButton";
import PersonalDetailsIcon from "../../assets/icons/personal_details.svg2";
import MyIcon from "../Common/MyIcon";
import Subheading from "../Common/Subheading";
import SmsSendSettings from "./SmsSendSettings";
import EmailSendSettings from "./EmailSendSettings";
import {
  useGetCommsSettingsDataQuery,
  useUpdateCommsSettingsDataMutation,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import MySuccessModal from "../Common/MySuccessModal";
import MyErrorModal from "../Common/MyErrorModal";
import WhatsAppSettings from "./WhatsAppSettings";
import VoiceSendSettings from "./VoiceSendSettings";
import NewFeature from "../Builder/Components/NewFeature";
import { isUserPermitted } from "../helpers/pageProps";

function CommunicationsSettings() {
  const { data } = useGetCommsSettingsDataQuery();
  const canEdit = isUserPermitted("edit_system_setting");
  const [communicationDefaults, setCommunicationDefaults] = useState({});
  const [errors, setErrors] = useState([]);

  const [save] = useUpdateCommsSettingsDataMutation();

  const handleSave = async () => {
    setErrors([]);
    const res = await save(communicationDefaults);
    if (res.error) {
      setErrors(res.error.data.error);
      return;
    }
    toast.success("Settings saved successfully");
  };

  useEffect(() => {
    if (!data) return;
    setCommunicationDefaults(data);
  }, [data]);

  const handleCommunicationDefaults = (e) =>
    setCommunicationDefaults((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  return (
    <div className="mb-5">
      <Subheading
        Icon={GeneralSettingsIcon}
        heading="Communication Settings"
        subheading="Your account default communications settings."
      />

      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3 ">
        <>
          <h5 className=" d-flex align-items-center">
            <MyIcon Icon={PersonalDetailsIcon} className="me-2" width={35} />
            <span className="ms-2">
              <span className="fw-bold me-2">Communication Defaults:</span>
              <HelpButton helpKey="settings-communication-defaults" />
              <div className="small text-secondary">
                These settings control options related to outbound message
                sending.
              </div>
            </span>
          </h5>
        </>
      </div>
      <fieldset disabled={!canEdit} className="border-0 p-0 m-0">
        <Row xs={1} xl={2}>
          <Col>
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3 ">
              <SmsSendSettings
                errors={errors}
                communicationDefaults={communicationDefaults}
                handleCommunicationDefaults={handleCommunicationDefaults}
                setCommunicationDefaults={setCommunicationDefaults}
                disabled={!canEdit}
              />
            </div>
          </Col>
          <Col>
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3">
              <EmailSendSettings
                handleCommunicationDefaults={handleCommunicationDefaults}
                communicationDefaults={communicationDefaults}
                setCommunicationDefaults={setCommunicationDefaults}
                disabled={!canEdit}
              />
            </div>
          </Col>
        </Row>
        <Row xs={1} xl={2}>
          <Col>
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3">
              <VoiceSendSettings
                errors={errors}
                handleCommunicationDefaults={handleCommunicationDefaults}
                communicationDefaults={communicationDefaults}
                setCommunicationDefaults={setCommunicationDefaults}
                disabled={!canEdit}
              />
            </div>
          </Col>
          <Col>
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3">
              <NewFeature>
                <WhatsAppSettings
                  handleCommunicationDefaults={handleCommunicationDefaults}
                  communicationDefaults={communicationDefaults}
                  setCommunicationDefaults={setCommunicationDefaults}
                  disabled={!canEdit}
                />
              </NewFeature>
            </div>
          </Col>
        </Row>
        <hr className="my-5 text-secondary " />
        <div className="d-flex justify-content-end">
          <NewFeature>
            <MyErrorModal />
            <MySuccessModal />
          </NewFeature>
          <button
            type="submit"
            className="btn btn-colored-reverse rounded-pill fw-bold "
            onClick={handleSave}
            disabled={!canEdit}
          >
            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
            SAVE SECTION
          </button>
        </div>
      </fieldset>
    </div>
  );
}

export default CommunicationsSettings;
